import React, { useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Tiles, Chip, img, when, fmt } from "./kit";

const FILTERS = [
  ["reported", "Şikayet edilenler"],
  ["hidden", "Gizlenenler"],
  ["active", "Yayında"],
  ["", "Hepsi"],
];

const Moments = () => {
  const [filter, setFilter] = useState("reported");
  const [data, setData] = useState(null);

  const load = async () => {
    const q = filter === "reported" ? { reported: 1 } : { status: filter };
    const r = await api.moments(q);
    setData(r?.status ? r : { moments: [], stats: {} });
  };
  useEffect(() => {
    setData(null);
    load();
    // eslint-disable-next-line
  }, [filter]);

  const act = async (id, action) => {
    if (action === "delete" && !window.confirm("Paylaşım kalıcı olarak kaldırılsın mı?")) return;
    await api.momentAction(id, action);
    load();
  };

  return (
    <>
      <PageHead title="Anlar" sub="Kullanıcı paylaşımları. 3 şikayet alan paylaşım otomatik gizlenir; şikayetleri 24 saat içinde incele (Apple kuralı)." />
      <Tiles
        items={[
          { label: "Yayında", value: fmt(data?.stats?.total) },
          { label: "Gizlenen", value: fmt(data?.stats?.hidden) },
          { label: "Açık şikayet", value: fmt(data?.stats?.openReports) },
        ]}
      />
      <div className="d-flex" style={{ gap: 6, marginBottom: 12 }}>
        {FILTERS.map(([k, l]) => (
          <button key={k} className={`btn btn-sm ${filter === k ? "btn-primary" : "btn-outline-secondary"}`} onClick={() => setFilter(k)}>
            {l}
          </button>
        ))}
      </div>
      {!data ? (
        <div className="badu-empty">Yükleniyor…</div>
      ) : !data.moments.length ? (
        <div className="badu-empty">Kayıt yok.</div>
      ) : (
        <div className="row">
          {data.moments.map((m) => (
            <div className="col-md-6 col-xl-4" key={m._id}>
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between" style={{ gap: 8 }}>
                    <div className="d-flex align-items-center" style={{ gap: 8 }}>
                      {m.authorImage && <img className="table_image" src={img(m.authorImage)} alt="" />}
                      <div>
                        <b>{m.authorName}</b>
                        <div style={{ fontSize: 12, color: "#6B7280" }}>{when(m.createdAt)} · {m.visibility === "public" ? "Herkese açık" : "Takipçiler"}</div>
                      </div>
                    </div>
                    <Chip kind={m.status === "active" ? "ok" : "bad"}>{{ active: "Yayında", hidden: "Gizli", deleted: "Silindi" }[m.status]}</Chip>
                  </div>
                  {m.text && <p style={{ margin: "10px 0", whiteSpace: "pre-wrap" }}>{m.text}</p>}
                  {m.images?.length > 0 && (
                    <div className="d-flex flex-wrap" style={{ gap: 4 }}>
                      {m.images.map((u) => (
                        <a key={u} href={img(u)} target="_blank" rel="noreferrer">
                          <img src={img(u)} alt="" style={{ width: 84, height: 84, objectFit: "cover", borderRadius: 8 }} />
                        </a>
                      ))}
                    </div>
                  )}
                  <div style={{ fontSize: 12, color: "#6B7280", margin: "8px 0" }}>
                    ❤ {fmt(m.likeCount)} · 💬 {fmt(m.commentCount)} · Şikayet {fmt(m.reportCount)}
                    {m.reasons?.length > 0 && <div style={{ color: "#B91C1C" }}>Sebep: {m.reasons.filter(Boolean).join(", ") || "belirtilmedi"}</div>}
                    {m.hiddenReason && <div>{m.hiddenReason}</div>}
                  </div>
                  <div className="d-flex flex-wrap" style={{ gap: 6 }}>
                    {m.status !== "hidden" && m.status !== "deleted" && <button className="btn btn-sm btn-outline-warning" onClick={() => act(m._id, "hide")}>Gizle</button>}
                    {m.status !== "active" && <button className="btn btn-sm btn-outline-success" onClick={() => act(m._id, "restore")}>Yayına al</button>}
                    {m.openReports > 0 && <button className="btn btn-sm btn-outline-secondary" onClick={() => act(m._id, "dismiss")}>Şikayeti kapat</button>}
                    {m.status !== "deleted" && <button className="btn btn-sm btn-outline-danger" onClick={() => act(m._id, "delete")}>Kaldır</button>}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default Moments;
